export default "__VITE_ASSET__D28x$KJ4__"